import { DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Lombard } from '@zero/lombard/domain';
import { ModalComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'lombard-conditions',
  templateUrl: './lombard-conditions.component.html',
  styleUrls: ['./lombard-conditions.component.scss'],
  imports: [TranslocoPipe, ModalComponent, DecimalPipe, TranslocoPipe, NgTemplateOutlet],
})
export class LombardConditionsComponent {
  public readonly modal = inject(NgbModal);

  @Input() public lombard: Lombard;
}
